module.exports = __webpack_public_path__ + "img/034.872402d8.jpg";